import { getOrCreateEncryptionKey } from 'common/utils/keychain/keychain';
import { createMMKV, useMMKVBoolean, useMMKVString } from 'react-native-mmkv';
export const KEYCHAIN_SERVICE = 'gagra.sharedStorage.encryption';
export const KEYCHAIN_USERNAME = 'mmkv';
let storageInstance = null;
export const initSharedStorage = async () => {
    if (storageInstance) {
        return storageInstance;
    }
    let encryptionKey = null;
    try {
        encryptionKey = await getOrCreateEncryptionKey(KEYCHAIN_USERNAME, KEYCHAIN_SERVICE);
    }
    catch (error) {
        console.error('Failed to init shared storage:', error);
    }
    storageInstance = createMMKV({
        id: 'gagra-storage',
        mode: 'single-process',
        ...(encryptionKey ? { encryptionKey } : {}),
    });
    return storageInstance;
};
export const getStorage = () => {
    if (!storageInstance) {
        throw new Error('Shared storage is not initialized. Call initSharedStorage() in index.js before importing App.');
    }
    return storageInstance;
};
export const sharedStorage = {
    getItem: (key) => getStorage().getString(key) ?? null,
    setItem: (key, val) => getStorage().set(key, val),
    removeItem: (key) => {
        getStorage().remove(key);
    },
    clearAll: () => getStorage().clearAll(),
};
export const useSharedStorageBoolean = (key) => {
    return useMMKVBoolean(key, getStorage());
};
export const useSharedStorageString = (key) => {
    return useMMKVString(key, getStorage());
};
